import React from 'react';
import {createRoot} from "react-dom/client";
import reportWebVitals from './reportWebVitals';
import Site from "./Site";
import './index.scss';

const rootElement = document.getElementById('root') as HTMLElement;

const ChaseOverlaySite = () => {
    return <Site />;
}

createRoot(rootElement).render(
    <React.StrictMode>
        <ChaseOverlaySite/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
